import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/Home.vue'
import Login from './components/Login.vue'
import ProjectSelection from './components/ProjectSelection.vue'
import MenuSelection from './components/MenuSelection.vue'
import Dashboard from './components/Dashboard.vue'
import WithHeader from './components/WithHeader.vue'
import UsersSummary from './components/UsersSummary.vue'
import UsersDetails from './components/UsersDetails.vue'
import TeamArrivalSummary from './components/TeamArrivalSummary.vue'
import TeamArrivalDetails from './components/TeamArrivalDetails.vue'
import TeamArrivalTeamRoute from './components/TeamArrivalTeamRoute.vue'
import TeamArrivalAreaDetails from './components/TeamArrivalAreaDetails.vue'
import TeamArrivalLiveLocation from './components/TeamArrivalLiveLocation.vue'
import TeamArrivalLiveLocationMap from './components/TeamArrivalLiveLocationMap.vue'
import SalesSummary from './components/SalesSummary.vue'
import SalesDetails from './components/SalesDetails.vue'
import SalesRecordDetails from './components/SalesRecordDetails.vue'
import SalesDetail from './components/SalesDetail.vue'
import TeamDetails from './components/TeamDetails.vue'
import SurveyDetails from './components/SurveyDetails.vue'
import SurveyReport from './components/SurveyReport.vue'
import TeamEdit from './components/TeamEdit.vue'
import TeamCreate from './components/TeamCreate.vue'
import UserEdit from './components/UserEdit.vue'
import UserCreate from './components/UserCreate.vue'
import UserDetail from './components/UserDetail.vue'
import TrialsSummary from './components/TrialsSummary.vue'
import TrialsDetails from './components/TrialsDetails.vue'
import TrialsByTeam from './components/TrialsByTeam.vue'
import CdcSummary from './components/CdcSummary.vue'
import CdcDetails from './components/CdcDetails.vue'
import CdcByTeam from './components/CdcByTeam.vue'
import CdcByBa from './components/CdcByBa.vue'
import CdcCustomerDetail from './components/CdcCustomerDetail.vue'
import ProductsSummary from './components/ProductsSummary.vue'
import ProductsDetails from './components/ProductsDetails.vue'
import ProductCreate from './components/ProductCreate.vue'
import ProductEdit from './components/ProductEdit.vue'
import PresetVenueSummary from './components/PresetVenueSummary.vue'
import PresetVenueDetails from './components/PresetVenueDetails.vue'
import PresetVenueCreate from './components/PresetVenueCreate.vue'
import Survey from './components/Survey.vue'
import SurveyFormCreate from './components/SurveyFormCreate.vue'
import SurveyFormEdit from './components/SurveyFormEdit.vue'
import SurveyFormPreview from './components/SurveyFormPreview.vue'
import PresetVenueEdit from './components/PresetVenueEdit.vue'
import SalesPromotionDetails from './components/SalesPromotionDetails.vue'
import ProductsPromotionDetails from './components/ProductsPromotionDetails.vue'
import ProductsPromotionCreate from './components/ProductsPromotionCreate.vue'
import ProductsPromotionEdit from './components/ProductsPromotionEdit.vue'
import StockCreate from './components/StockCreate.vue'
import StockDetail from './components/StockDetail.vue'
import VenueAnalysisDetails from './components/VenueAnalysisDetails.vue'
import VenueAnalysisSummary from './components/VenueAnalysisSummary.vue'
import VenueAnalysisFullMap from './components/VenueAnalysisFullMap.vue'
import AssetsSummary from './components/AssetsSummary.vue'
import AssetsUniformsDetails from './components/AssetsUniformsDetails.vue'
import AssetsShoesDetails from './components/AssetsShoesDetails.vue'
import AssetsTabletsDetails from './components/AssetsTabletsDetails.vue'
import AssetsTabletsAreaDetails from './components/AssetsTabletsAreaDetails.vue'
import AssetsTransfer from './components/AssetsTransfer.vue'
import AssetsCreate from './components/AssetsCreate.vue'
import OtpsSummary from './components/OtpsSummary.vue'
import OtpsDetails from './components/OtpsDetails.vue'
import AttendanceSummary from './components/AttendanceSummary.vue'
import AnnouncementsDetails from './components/AnnouncementsDetails.vue'
import AnnouncementsCreate from './components/AnnouncementsCreate.vue'
import AnnouncementsEdit from './components/AnnouncementsEdit.vue'
import AnnouncementsDetail from './components/AnnouncementsDetail.vue'
import AttendanceDetails from './components/AttendanceDetails.vue'
import PayrollDetails from './components/PayrollDetails.vue'
import Error404 from './components/404.vue'
import Changelogs from './components/Changelogs.vue'
import venueMobile from './components/venueMobile.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: "/",
    routes: [
        {
            path: '',
            name: 'home',
            component: Home,
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/project/selection',
            name: 'projectSelection',
            component: ProjectSelection,
        },
        {
            path: '/menu/selection',
            name: 'menuSelection',
            component: MenuSelection,
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
        },
        {
            path: '/sales-record/details/:type/:date/:userId',
            name: 'salesRecordDetails',
            component: SalesRecordDetails,
        },
        {
            path: '/venue-mobile/venueMobile',
            name: 'venueMobile',
            component: venueMobile,
        },
        {
            path: '/survey/:id',
            name: 'Survey',
            component: Survey,
        },
        {
            path: '',
            name: 'withHeader',
            component: WithHeader,
            children: [
                {
                    path: 'users/summary',
                    name: 'usersSummary',
                    component: UsersSummary,
                },
                {
                    path: 'users/details',
                    name: 'usersDetails',
                    component: UsersDetails,
                },
                {
                    path: 'user/edit/:id',
                    name: 'userEdit',
                    component: UserEdit,
                },
                {
                    path: 'user/detail/:id',
                    name: 'userDetail',
                    component: UserDetail,
                },
                {
                    path: 'user/create',
                    name: 'userCreate',
                    component: UserCreate,
                },
                {
                    path: 'sales/summary',
                    name: 'salesSummary',
                    component: SalesSummary,
                },
                {
                    path: 'sales/details',
                    name: 'salesDetails',
                    component: SalesDetails,
                },
                {
                    path: 'sales/detail',
                    name: 'salesDetail',
                    component: SalesDetail,
                },
                {
                    path: 'team-arrival/summary',
                    name: 'teamArrivalSummary',
                    component: TeamArrivalSummary,
                },
                {
                    path: '/team-arrival/details',
                    name: 'teamArrivalDetails',
                    component: TeamArrivalDetails,
                },
                {
                    path: '/team-arrival/teamroute/:id',
                    name: 'teamArrivalTeamRoute',
                    component: TeamArrivalTeamRoute,
                },
                {
                    path: '/team-arrival/areadetails/:id/:venue_id',
                    name: 'teamArrivalAreaDetails',
                    component: TeamArrivalAreaDetails,
                },
                {
                    path: '/team-arrival/livelocation',
                    name: 'teamArrivalLiveLocation',
                    component: TeamArrivalLiveLocation,
                },
                {
                    path: '/team-arrival/livelocation/map/:area_id',
                    name: 'teamArrivalLiveLocationMap',
                    component: TeamArrivalLiveLocationMap,
                },
                
                {
                    path: 'survey-form/details',
                    name: 'surveyDetails',
                    component: SurveyDetails,
                },
                {
                    path: 'team/details',
                    name: 'teamDetails',
                    component: TeamDetails,
                },
                {
                    path: 'team/edit/:id',
                    name: 'teamEdit',
                    component: TeamEdit,
                },
                {
                    path: 'team/create',
                    name: 'teamCreate',
                    component: TeamCreate,
                },
                {
                    path: 'trials/summary',
                    name: 'trialsSummary',
                    component: TrialsSummary,
                },
                {
                    path: 'trials/details',
                    name: 'trialsDetails',
                    component: TrialsDetails,
                },
                {
                    path: '/trials/team/:wptlid',
                    name: 'trialsByTeam',
                    component: TrialsByTeam,
                },
                {
                    path: 'cdc/details',
                    name: 'cdcDetails',
                    component: CdcDetails,
                },
                {
                    path: '/cdc/team/:wptlid',
                    name: 'cdcByTeam',
                    component: CdcByTeam,
                },
                {
                    path: '/cdc/ba/:wpbaid/:venue_id',
                    name: 'cdcByBa',
                    component: CdcByBa,
                },
                {
                    path: '/cdc/customer/detail/:cid/:eid',
                    name: 'cdcCustomerDetail',
                    component: CdcCustomerDetail,
                },
                {
                    path: 'cdc/summary',
                    name: 'cdcSummary',
                    component: CdcSummary,
                },
                {
                    path: 'survey-form/create',
                    name: 'surveyFormCreate',
                    component: SurveyFormCreate,
                },
                {
                    path: 'survey-form/report/:id',
                    name: 'surveyReport',
                    component: SurveyReport,
                },
                {
                    path: 'survey-form/edit/:id',
                    name: 'surveyFormEdit',
                    component: SurveyFormEdit,
                },
                {
                    path: 'survey-form/preview',
                    name: 'surveyFormPreview',
                    component: SurveyFormPreview,
                },
                {
                    path: 'preset-venue/create',
                    name: 'presetVenueCreate',
                    component: PresetVenueCreate,
                },
                {
                    path: 'preset-venue/edit/:id',
                    name: 'presetVenueEdit',
                    component: PresetVenueEdit,
                },
                {
                    path: 'products/summary',
                    name: 'productsSummary',
                    component: ProductsSummary,
                },
                {
                    path: 'products/details',
                    name: 'productsDetails',
                    component: ProductsDetails,
                },
                {
                    path: 'product/create',
                    name: 'productCreate',
                    component: ProductCreate,
                },
                {
                    path: 'product/edit/:id',
                    name: 'productEdit',
                    component: ProductEdit,
                },
                {
                    path: 'products/promotion/details',
                    name: 'productsPromotionDetails',
                    component: ProductsPromotionDetails,
                },
                {
                    path: 'sales/promotion/details',
                    name: 'salesPromotionDetails',
                    component: SalesPromotionDetails,
                },
                {
                    path: 'products/promotion/create',
                    name: 'productsPromotionCreate',
                    component: ProductsPromotionCreate,
                },
                {
                    path: 'products/promotion/edit/:id',
                    name: 'productsPromotionEdit',
                    component: ProductsPromotionEdit,
                },
                {
                    path: 'preset-venue/summary',
                    name: 'presetVenueSummary',
                    component: PresetVenueSummary,
                },
                {
                    path: 'preset-venue/details',
                    name: 'presetVenueDetails',
                    component: PresetVenueDetails,
                },
                
                {
                    path: 'stock/create',
                    name: 'stockCreate',
                    component: StockCreate,
                },
                {
                    path: 'stock/detail',
                    name: 'stockDetail',
                    component: StockDetail,
                },
                {
                    path: 'venue-analysis/details',
                    name: 'venueAnalysisDetails',
                    component: VenueAnalysisDetails,
                },
                {
                    path: 'venue-analysis/summary',
                    name: 'venueAnalysisSummary',
                    component: VenueAnalysisSummary,
                },
                {
                    path: 'venue-analysis/map',
                    name: 'venueAnalysisFullMap',
                    component: VenueAnalysisFullMap,
                },
                {
                    path: 'assets/summary',
                    name: 'assetsSummary',
                    component: AssetsSummary,
                },
                {
                    path: 'assets/uniforms/details',
                    name: 'assetsUniformsDetails',
                    component: AssetsUniformsDetails,
                },
                {
                    path: 'assets/shoes/details',
                    name: 'assetsShoesDetails',
                    component: AssetsShoesDetails,
                },
                {
                    path: 'assets/tablets/details',
                    name: 'assetsTabletsDetails',
                    component: AssetsTabletsDetails,
                },
                {
                    path: 'assets/tablets/details/area/:id',
                    name: 'assetsTabletsAreaDetails',
                    component: AssetsTabletsAreaDetails,
                },
                {
                    path: 'assets/transfer',
                    name: 'assetsTransfer',
                    component: AssetsTransfer,
                },
                {
                    path: 'assets/create',
                    name: 'assetsCreate',
                    component: AssetsCreate,
                },
                {
                    path: 'otps/summary',
                    name: 'otpsSummary',
                    component: OtpsSummary,
                },
                {
                    path: 'otps/details',
                    name: 'otpsDetails',
                    component: OtpsDetails,
                },
                {
                    path: 'announcements/details',
                    name: 'announcementsDetails',
                    component: AnnouncementsDetails,
                },
                {
                    path: 'announcements/create',
                    name: 'announcementsCreate',
                    component: AnnouncementsCreate,
                },
                {
                    path: 'announcements/edit/:id',
                    name: 'announcementsEdit',
                    component: AnnouncementsEdit,
                },
                {
                    path: 'announcements/detail/:id',
                    name: 'announcementsDetail',
                    component: AnnouncementsDetail,
                },
                {
                    path: '404',
                    name: 'error404',
                    component: Error404,
                },
                {
                    path: 'changelogs',
                    name: 'changelogs',
                    component: Changelogs,
                },
                {
                    path: "attendance/summary",
                    name: "attendancesSummary",
                    component: AttendanceSummary
                },
                {
                    path: 'attendance/details',
                    name: 'attendanceDetails',
                    component: AttendanceDetails
                },
                {
                    path: 'payroll/details',
                    name: 'payrollDetails',
                    component: PayrollDetails
                }
            ]
        },
        
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition
        } else {
          return { x: 0, y: 0 }
        }
    }    
})
